export enum BannerStatus {
  Upcoming = 'Upcoming',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  PendingApproval = 'PendingApproval',
}

export interface BannerDataProps {
  orgName?: string
  startTime?: string
  endTime?: string
  message?: string
  bannerType?: BannerStatus
  bannerSeverity?: number
  createdBy34: string
}

export interface ApprovalListItem {
  hca34: string
  userName: string
  isApproved: boolean
  timeStamp: string
}

export interface GETBannerDataProps {
  id: string
  partitionKey: string
  bannerStatus: BannerStatus | string
  bannerType: number
  bannerSeverity: number
  contents: string
  createdBy: string
  createdBy34: string
  endDate: string
  header: string
  scope: string
  startDate: string
  timer: number
  lastUpdatedTime: string
  approvalList: ApprovalListItem[]
}
